import { createContext, useContext } from "react";
import type { AppMetaData } from "../../types/meta-data/meta-data";
import type { OperatorData } from "../../types/operator/operator";

interface MetaDataContextType {
  metaData: AppMetaData;
  operators: OperatorData[];
  qrPaymentCommissionAmount: number;
  qrPaymentCommissionOriginalAmount: number;
}

const MetaDataContext = createContext<MetaDataContextType>({
  metaData: {} as AppMetaData,
  operators: [],
  qrPaymentCommissionAmount: 0,
  qrPaymentCommissionOriginalAmount: 0,
});

const useMetaDataContext = () => {
  const context = useContext(MetaDataContext);
  if (!context) {
    throw new Error("useMetaDataContext must be used within a MetaDataProvider");
  }
  return context;
};

export { MetaDataContext, useMetaDataContext };
